import React from "react";
import { ShieldCheck } from "lucide-react";
import { Reveal } from "./common";

export const Guarantee = () => {
  return (
    <section id="garantia" data-testid="guarantee-section" className="pb-14 sm:pb-20">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6">
        <Reveal>
          <div className="flex flex-col items-center gap-6 rounded-3xl border border-[hsl(var(--border))] bg-[hsl(var(--brand-sun))]/15 p-8 text-center sm:p-12">
            <div
              data-testid="guarantee-seal"
              className="flex h-28 w-28 items-center justify-center rounded-full border-4 border-dashed border-[hsl(var(--brand-coral))]/50 bg-white"
            >
              <div className="flex h-20 w-20 flex-col items-center justify-center rounded-full bg-[hsl(var(--brand-coral))] text-white">
                <ShieldCheck className="h-7 w-7" />
                <span className="mt-0.5 text-xs font-extrabold leading-none">7 DÍAS</span>
              </div>
            </div>
            <h2 className="font-heading text-2xl font-extrabold text-[hsl(var(--brand-ink))] sm:text-3xl">
              Tu compra está 100% protegida
            </h2>
            <p className="max-w-xl text-base leading-relaxed text-muted-foreground">
              Prueba el ebook durante <strong className="text-[hsl(var(--brand-ink))]">7 días</strong>. Si no quedas
              completamente satisfecho, te devolvemos el <strong className="text-[hsl(var(--brand-ink))]">100% de tu
              dinero</strong>, sin preguntas. El riesgo es totalmente nuestro.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
